export const POLLABLE_STATUSES = ['scheduled', 'importing'];

export const getDefaultDetailTab = (status) => {
  if (["draft", "ready_for_import"].includes(status)) return "mapping";
  if (["scheduled", "importing"].includes(status)) return "details";
  if (["completed", "partially_completed", "failed"].includes(status)) return "records";
  return "details";
};

export const CORE_RECORD_FIELDS = ['user:first_name', 'user:last_name', 'employee_number'];

const isMappedInScope = (field, fieldMapping, inScopeFields) =>
  Boolean(fieldMapping?.[field]) && (inScopeFields || []).some(f => f.key === field);

// Record table columns: core fields only while they are mapped; status and log always.
export const getVisibleRecordHeaders = (baseHeaders, fieldMapping, inScopeFields) => {
  if (!fieldMapping) return baseHeaders;
  return baseHeaders.filter(h => !CORE_RECORD_FIELDS.includes(h.field) || isMappedInScope(h.field, fieldMapping, inScopeFields));
};

// Mapped fields that have no own column; shown in the expanded record details.
export const getDetailRecordFields = (baseHeaders, fieldMapping, inScopeFields) =>
  (inScopeFields || []).filter(f => fieldMapping?.[f.key] && !baseHeaders.some(h => h.field === f.key));

// Cells follow the header order, not the mapping order, so each value sits under its own header.
export const buildRecordCells = (recordData, fieldMapping, headers, { status, log }) =>
  headers.map(({ field }) => {
    if (field === 'table_status') return status;
    if (field === 'table_log') return log;
    return recordData?.[fieldMapping?.[field]] || '-';
  });

export const operationAlts = {
  create: 'Erstellen',
  update: 'Aktualisieren'
};

export const operationStatusAlts = {
  pending: 'Ausstehend',
  imported: 'Importiert',
  failed: 'Fehlgeschlagen',
  skipped: 'Übersprungen',
  conflicted: 'Konflikt'
};
